// extracted by mini-css-extract-plugin
module.exports = {"container":"SummaryStatement_container__e37Pd","rowAmount":"SummaryStatement_rowAmount__X3EvK"};